import FavouriteButton from 'components/common/FavouriteButton';
import PropertyStatusWrapper from 'components/common/PropertyStatusWrapper';
import Link from 'next/link';
import React from 'react';
import { AddressSVG } from '../Icons';

import styles from './styles.scss';

interface PropertyData {
  tilstandsrapportId: string;
  boligtype: string;
  size: number;
  byggear: number;
  address: string;
  tgCount: any;
};

interface StateProps {
  propertyData: PropertyData;
  isFavourite: boolean;
};

interface CallbackProps {
  onClickFavourite: Function;
};

const PropertyDataBanner = ({
  propertyData,
  isFavourite,
  onClickFavourite }: StateProps & CallbackProps): JSX.Element => {
  return (
    <div className={styles.property}>
      <div className={styles.favouriteButtonContainer}>
        <FavouriteButton
          className={styles.favouriteButton}
          onClick={onClickFavourite(isFavourite)}
          isFavourite={isFavourite}
        />
      </div>

      <Link href={`/list?tilstandsrapportId=${propertyData?.tilstandsrapportId}`} as={`/${propertyData?.tilstandsrapportId}/utbedringsplan`}>
        <a className={styles.statusBarLink} data-track-id="utbedring-overview">
          <div className={styles.address}>
            <AddressSVG />
            <h1>{propertyData?.address}</h1>
          </div>
          <PropertyStatusWrapper
            title={null}
            tg1Count={propertyData?.tgCount?.tg1}
            tg2Count={propertyData?.tgCount?.tg2}
            tg3Count={propertyData?.tgCount?.tg3}
          />
          <dl className={styles.propertyAttributes}>
            <div>
              <dd>{propertyData?.boligtype}</dd>
              <dt>Boligtype</dt>
            </div>
            <div>
              <dd>{propertyData?.size} kvm</dd>
              <dt>Størrelse</dt>
            </div>
            <div>
              <dd>{propertyData?.byggear}</dd>
              <dt>Byggeår</dt>
            </div>
          </dl>
        </a>
      </Link>
    </div>
  );
};

export default React.memo(PropertyDataBanner);
